var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQ3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 408.9,
    height: 141.841,
    viewBox: "0 0 408.9 141.841",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_256",
    "data-name": "Rettangolo 256",
    width: 68.258,
    height: 141.841,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3507",
    "data-name": "Tracciato 3507",
    d: "M2.276,93.747l3.271,1.9c-.957-.556-.981-2.22.114-4.446l-3.27-1.9c-1.1,2.228-1.071,3.893-.116,4.446",
    transform: "translate(-1.564 -89.301)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3510",
    "data-name": "Tracciato 3510",
    d: "M9.79,76.558l3.271,1.9A64.018,64.018,0,0,0,17.232,66.9L13.962,65A64.087,64.087,0,0,1,9.79,76.558",
    transform: "translate(-9.79 -64.999)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3512",
    "data-name": "Tracciato 3512",
    d: "M28.1,35.417l3.269,1.9a4.434,4.434,0,0,1,4.444-.285l-3.271-1.9a3.627,3.627,0,0,0-1.834-.472,5.215,5.215,0,0,0-2.607.756",
    transform: "translate(-28.098 -34.661)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3519",
    "data-name": "Tracciato 3519",
    d: "M17.547,47.177l3.271,1.9a14.92,14.92,0,0,1,5.91-8.459l-3.269-1.9c-2.519,1.466-5.178,5.263-5.912,8.46",
    transform: "translate(-17.547 -38.717)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3524",
    "data-name": "Tracciato 3524",
    d: "M25.37,19.176l6.54,3.8c.918-.506,2.323-.342,3.793.512l-6.542-3.8a5.262,5.262,0,0,0-2.575-.8,2.5,2.5,0,0,0-1.217.285",
    transform: "translate(-25.37 -18.891)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3527",
    "data-name": "Tracciato 3527",
    d: "M17.754,44.647l6.542,3.8c.038-11.161,7.143-23.936,9.9-25.537l-6.54-3.8c-2.754,1.6-9.861,14.376-9.9,25.537",
    transform: "translate(-17.754 -19.11)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3532",
    "data-name": "Tracciato 3532",
    d: "M41.315,81.449a4.24,4.24,0,0,1,.636,2.766.753.753,0,0,1-.341.412l2.181-1.267a.757.757,0,0,0,.341-.413,4.237,4.237,0,0,0-.636-2.765Z",
    transform: "translate(-41.315 -80.182)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3535",
    "data-name": "Tracciato 3535",
    d: "M30.73,59.938c.129.268.256.556.383.812l2.18-1.267c-.127-.256-.256-.545-.383-.812Z",
    transform: "translate(-30.73 -58.671)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Domanda_3.3",
    "data-name": "Domanda 3.3",
    transform: "translate(14.213 -102.159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1,
    transform: "translate(246.796 251.995) rotate(179)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_721",
    "data-name": "Raggruppa 721",
    transform: "translate(-47.792 16.647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3778",
    "data-name": "Tracciato 3778",
    d: "M11.055,70.787C-7.6,63.706,2.288,46.6,5.481,31.059c.882-4.3,8.185-8.432,21.18-11.332,28.361-6.321,60.375-2.1,88.142,1.373,22.026,2.754,49.858,5.047,70.19,1.6,14.839-2.515,19.951-7.183,27.314-11.214,9.484-5.19,26.144-10.092,48.9-11.238,28.589-1.44,56.913,3.6,71.46,9.8s19.179,13.436,27.584,20.277c12.008,9.783,32.027,18.934,41.8,28.864s7.414,21.43-20.614,29c-22.072,5.958-56.758,8.435-89.57,8.007s-64.152-3.443-93.557-7.034c-23.515-2.87-47.4-6.213-73.671-6.365-17.454-.1-52.934.142-68.715-1.688-17.36-2.013-34.463-6.368-44.87-10.32",
    transform: "translate(-100.734 18.414)",
    fill: "#3f3d94"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_2",
    "data-name": 2,
    transform: "translate(260.69 102.159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_394",
    "data-name": "Raggruppa 394"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_393",
    "data-name": "Raggruppa 393",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3443",
    "data-name": "Tracciato 3443",
    d: "M40.41,75.1H53.166l4.251,8.93a8.5,8.5,0,0,1-.1,1.2c-.3,1.957-1.935,5.812-10.534,6.1-11.595.386-10.627-7.3-10.627-7.3Z",
    transform: "translate(10.832 22.511)",
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3444",
    "data-name": "Tracciato 3444",
    d: "M37.49,85.018a7.957,7.957,0,0,0,1.748,1.341,11.92,11.92,0,0,0,2.194.979c4.059,1.362,9.35,1.036,12.843-.98,2.1-1.21,3.144-2.8,3.138-4.385l.01,1.5c.005,1.586-1.042,3.174-3.139,4.384-3.49,2.016-8.784,2.343-12.841.981a11.939,11.939,0,0,1-2.2-.98,7.984,7.984,0,0,1-1.748-1.34,4.319,4.319,0,0,1-1.34-2.983l-.01-1.5a4.324,4.324,0,0,0,1.341,2.983",
    transform: "translate(10.835 24.57)",
    fill: "#ffc400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3445",
    "data-name": "Tracciato 3445",
    d: "M50.931,74.45c2.852,1.591,2.945,4.214.209,5.86a11.144,11.144,0,0,1-10.116.1c-2.852-1.591-2.945-4.214-.209-5.86a11.144,11.144,0,0,1,10.116-.1m-4.953,2.982Z",
    transform: "translate(11.637 21.967)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3446",
    "data-name": "Tracciato 3446",
    d: "M52.674,97.142c.074-23.051.149-62.308.224-85.359a3.643,3.643,0,0,0-2.21-3.015,11.192,11.192,0,0,0-10.156.1l-.175,85.37a11.144,11.144,0,0,1,10.116-.1,3.629,3.629,0,0,1,2.2,3",
    transform: "translate(12.096 2.278)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3447",
    "data-name": "Tracciato 3447",
    d: "M44.328,96.161h0l.2-85.359c-.058,20.745-.138,64.614-.2,85.359",
    transform: "translate(13.287 3.238)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3448",
    "data-name": "Tracciato 3448",
    d: "M44.328,96.161l.2-85.359Z",
    transform: "translate(13.287 3.238)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3449",
    "data-name": "Tracciato 3449",
    d: "M44.524,10.8l-.2,85.359c.058-20.745.138-64.614.2-85.359",
    transform: "translate(13.287 3.238)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3450",
    "data-name": "Tracciato 3450",
    d: "M44.328,96.161l.2-85.359Z",
    transform: "translate(13.287 3.238)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3451",
    "data-name": "Tracciato 3451",
    d: "M44.524,10.8l-.2,85.359Z",
    transform: "translate(13.287 3.238)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3452",
    "data-name": "Tracciato 3452",
    d: "M44.328,96.161h0l.2-85.359c-.058,20.745-.138,64.614-.2,85.359",
    transform: "translate(13.287 3.238)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3453",
    "data-name": "Tracciato 3453",
    d: "M44.524,10.8l-.2,85.359Z",
    transform: "translate(13.287 3.238)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3454",
    "data-name": "Tracciato 3454",
    d: "M44.524,10.8l-.2,85.359c.058-20.745.138-64.614.2-85.359",
    transform: "translate(13.287 3.238)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3455",
    "data-name": "Tracciato 3455",
    d: "M38.991,11.448l-.168,85.359a3.5,3.5,0,0,1,1.991-2.859L40.99,8.578a3.517,3.517,0,0,0-2,2.87",
    transform: "translate(11.637 2.571)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3456",
    "data-name": "Tracciato 3456",
    d: "M53.355,10.821c-.01,2.985-.02,6.243-.03,9.71,0,1.413,0,2.866-.01,4.349,0,2.945-.009,6.013-.02,9.158,0,1.393-.01,2.817-.01,4.24-.01,3.036-.019,6.122-.03,9.239,0,1.373,0,2.755-.01,4.149,0,3.1-.009,6.2-.019,9.289,0,1.373-.01,2.745-.01,4.108-.01,3.166-.019,6.292-.03,9.339,0,1.373,0,2.726-.01,4.058,0,3.268-.009,6.4-.02,9.389,0,1.374-.01,2.706-.01,4.008,0,1.493-.01,2.946-.01,4.329a3.519,3.519,0,0,1-1.994,2.856,11.151,11.151,0,0,1-10.121.1,3.624,3.624,0,0,1-2.194-3.006l.01-4.528.01-4.7.019-8.658.01-4.71.009-8.658.01-4.71.019-8.647.01-4.73.019-8.628V33.417l.021-8.6.01-4.589L39,10.8a3.648,3.648,0,0,0,2.2,3,11.207,11.207,0,0,0,10.161-.11,3.5,3.5,0,0,0,1.994-2.866",
    transform: "translate(11.637 3.238)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3457",
    "data-name": "Tracciato 3457",
    d: "M40.952,8.871c-2.746,1.653-2.651,4.287.211,5.883a11.188,11.188,0,0,0,10.156-.1c2.746-1.653,2.651-4.287-.211-5.883a11.188,11.188,0,0,0-10.156.1",
    transform: "translate(11.675 2.278)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3458",
    "data-name": "Tracciato 3458",
    d: "M40.952,8.871c-2.746,1.653-2.653,4.287.211,5.883a11.188,11.188,0,0,0,10.156-.1c2.746-1.653,2.651-4.287-.211-5.883a11.188,11.188,0,0,0-10.156.1",
    transform: "translate(11.675 2.278)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3459",
    "data-name": "Tracciato 3459",
    d: "M38.955,12.587a3.586,3.586,0,0,1,2-2.753,6.415,6.415,0,0,1,3.017-5.446,10.983,10.983,0,0,0-3.7,3.846,10.78,10.78,0,0,0-1,2.4,9.658,9.658,0,0,0-.312,1.954",
    transform: "translate(11.676 1.315)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3460",
    "data-name": "Tracciato 3460",
    d: "M43.508,4.566a6.415,6.415,0,0,0-3.017,5.445,11.192,11.192,0,0,1,10.156-.1,3.715,3.715,0,0,1,2.207,2.9A9.782,9.782,0,0,0,51.9,9.088a11.112,11.112,0,0,0-2.59-3.444A7.006,7.006,0,0,0,46.1,3.834a3.838,3.838,0,0,0-2.593.732",
    transform: "translate(12.137 1.139)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3461",
    "data-name": "Tracciato 3461",
    d: "M48.08,4.42c-1.47-.8-2.312-.9-4.111.144a2.787,2.787,0,0,1,2.191-.538,2.787,2.787,0,0,0-2.191.538,10.765,10.765,0,0,0-3.526,3.55,9.792,9.792,0,0,0-1.487,4.649c-.057,1.135.682,2.28,2.207,3.13a11.188,11.188,0,0,0,10.156-.1,3.456,3.456,0,0,0,2-2.985,9.4,9.4,0,0,0-.522-2.676,10.859,10.859,0,0,0-1.133-2.29A10.712,10.712,0,0,0,48.08,4.42",
    transform: "translate(11.675 1.139)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3462",
    "data-name": "Tracciato 3462",
    d: "M53.292,18.357c0,1.413,0,2.866-.01,4.349-.03.019-.049.03-.079.051a13.886,13.886,0,0,1-7.035,1.753,14.257,14.257,0,0,1-6.794-1.6c-.149-.079-.3-.17-.441-.26l.01-4.589c.049.781.741,1.573,1.894,2.224a12.157,12.157,0,0,0,10.822-.1,3.32,3.32,0,0,0,1.634-1.824",
    transform: "translate(11.67 5.412)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3463",
    "data-name": "Tracciato 3463",
    d: "M53.267,28.823c0,1.393-.012,2.815-.012,4.238-.02.01-.03.021-.049.03a13.972,13.972,0,0,1-7.033,1.755,14.146,14.146,0,0,1-6.8-1.614c-.16-.09-.311-.181-.46-.281V28.2h.019c-.048.832.651,1.713,1.9,2.4a12.091,12.091,0,0,0,10.822-.1,3.525,3.525,0,0,0,1.605-1.683",
    transform: "translate(11.665 8.453)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3464",
    "data-name": "Tracciato 3464",
    d: "M53.234,39.216c0,1.373,0,2.755-.01,4.149a.009.009,0,0,1-.009.009,13.878,13.878,0,0,1-7.035,1.764,14.142,14.142,0,0,1-6.794-1.613,4.918,4.918,0,0,1-.491-.3l.01-4.73h.04c-.051.832.651,1.7,1.9,2.4a12.124,12.124,0,0,0,10.822-.1,3.714,3.714,0,0,0,1.564-1.583",
    transform: "translate(11.658 11.538)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3465",
    "data-name": "Tracciato 3465",
    d: "M53.211,49.568c0,1.373-.01,2.746-.01,4.108a13.935,13.935,0,0,1-7.013,1.753,14.263,14.263,0,0,1-6.8-1.613c-.179-.1-.36-.211-.521-.321l.01-4.709h.07c-.049.832.651,1.7,1.9,2.4a12.124,12.124,0,0,0,10.822-.1,3.768,3.768,0,0,0,1.534-1.523",
    transform: "translate(11.651 14.623)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3466",
    "data-name": "Tracciato 3466",
    d: "M53.175,59.934c0,1.373,0,2.726-.01,4.058a13.9,13.9,0,0,1-6.974,1.734A14.258,14.258,0,0,1,39.4,64.112c-.19-.11-.37-.211-.541-.33l.01-4.71h.09c-.051.832.651,1.713,1.9,2.415a12.124,12.124,0,0,0,10.822-.1,3.784,3.784,0,0,0,1.493-1.453",
    transform: "translate(11.646 17.706)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3467",
    "data-name": "Tracciato 3467",
    d: "M53.152,70.3c0,1.373-.01,2.706-.01,4.008a13.9,13.9,0,0,1-6.944,1.7,14.257,14.257,0,0,1-6.794-1.6c-.2-.11-.39-.23-.571-.351l.01-4.7.12.01c-.051.832.651,1.713,1.9,2.415a12.157,12.157,0,0,0,10.822-.1A3.918,3.918,0,0,0,53.152,70.3",
    transform: "translate(11.64 20.788)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3468",
    "data-name": "Tracciato 3468",
    d: "M44.062,8.4a1.521,1.521,0,1,1-3.017,0,1.521,1.521,0,1,1,3.017,0",
    transform: "translate(12.303 2.001)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3469",
    "data-name": "Tracciato 3469",
    d: "M28.456,78.693,14.923,71.172C7.752,75.488,8,82.365,15.472,86.532s19.347,4.047,26.517-.268,6.925-11.193-.55-15.36-19.345-4.047-26.516.268Z",
    transform: "translate(2.908 20.339)",
    fill: "#d83736"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3470",
    "data-name": "Tracciato 3470",
    d: "M9.7,95.667c0-2.7,1.735-5.406,5.221-7.5l.092-76.992C11.507,13.283,9.763,16,9.76,18.722c-.017,19.026-.04,57.92-.058,76.944",
    transform: "translate(2.908 3.348)",
    fill: "#d83736"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3471",
    "data-name": "Tracciato 3471",
    d: "M46.307,19.6c.013-2.884-1.931-5.771-5.807-7.932-7.523-4.194-19.471-4.073-26.689.27l-.092,76.992c7.171-4.316,19.042-4.436,26.517-.269,3.851,2.148,5.784,5.016,5.77,7.882.1-21.14.2-55.8.3-76.943",
    transform: "translate(4.112 2.578)",
    fill: "#d83736"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3472",
    "data-name": "Tracciato 3472",
    d: "M9.748,21.486C9.79,18.8,11.534,16.112,15,14.025A14.84,14.84,0,0,1,22.179,1.649a26.445,26.445,0,0,0-4.457,3.43A27.054,27.054,0,0,0,15.08,7.957a19.783,19.783,0,0,0-1.452,1.987c-.545.87-1.243,2.05-1.705,2.966a20.514,20.514,0,0,0-1.032,2.455,23.168,23.168,0,0,0-.785,2.837,30.178,30.178,0,0,0-.357,3.283",
    transform: "translate(2.922 0.494)",
    fill: "#ff4140"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3473",
    "data-name": "Tracciato 3473",
    d: "M28.623,19.511,15,11.941c-7.217,4.344-6.97,11.265.552,15.459s19.471,4.073,26.687-.27,6.969-11.265-.554-15.459S22.219,7.6,15,11.941Z",
    transform: "translate(2.922 2.578)",
    fill: "#ff4140"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3474",
    "data-name": "Tracciato 3474",
    d: "M20.966,2.141A14.839,14.839,0,0,0,13.79,14.517c7.216-4.344,19.166-4.465,26.687-.27,3.836,2.139,5.78,4.987,5.807,7.84-.038-.862-.144-2.011-.261-2.867a14.826,14.826,0,0,0-.351-1.629A23.208,23.208,0,0,0,43.8,12.774a27.482,27.482,0,0,0-3.231-4.821,28.489,28.489,0,0,0-4.2-4.1A16.9,16.9,0,0,0,28.509.067C26.124-.2,23.94.4,20.966,2.141",
    transform: "translate(4.133 0.002)",
    fill: "#ff4140"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3475",
    "data-name": "Tracciato 3475",
    d: "M47.21,94.034c.1-21.139.2-55.8.3-76.943-.013,2.713-1.757,5.422-5.255,7.528-7.217,4.344-19.166,4.465-26.689.269-3.865-2.155-5.81-5.031-5.807-7.908L9.7,93.925c0,2.857,1.929,5.715,5.77,7.857,7.475,4.167,19.347,4.047,26.517-.268,3.475-2.093,5.208-4.786,5.221-7.48",
    transform: "translate(2.908 5.09)",
    fill: "#d83736"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3476",
    "data-name": "Tracciato 3476",
    d: "M15,11.941l13.62,7.57L15,11.941c-7.217,4.344-6.969,11.265.552,15.459s19.471,4.075,26.689-.269,6.969-11.266-.554-15.46S22.219,7.6,15,11.941",
    transform: "translate(2.921 2.578)",
    fill: "#d83736"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3477",
    "data-name": "Tracciato 3477",
    d: "M34.482,1.773c-4.509-2.467-7.613-2.373-12.3.37C24.63.667,27.14.221,28.682,1.076,27.14.221,24.63.667,22.178,2.143A24.7,24.7,0,0,0,19.4,4.1a28.545,28.545,0,0,0-6.261,7.1,23.955,23.955,0,0,0-2.486,5.372,21.069,21.069,0,0,0-.625,2.541,28.16,28.16,0,0,0-.278,2.863c-.044,2.908,1.9,5.822,5.807,8,7.523,4.194,19.471,4.073,26.689-.27,3.537-2.129,5.281-4.877,5.254-7.619a29.88,29.88,0,0,0-.338-3.284,23.414,23.414,0,0,0-.769-2.843,24.569,24.569,0,0,0-2.706-5.437,27.666,27.666,0,0,0-9.2-8.752",
    transform: "translate(2.921 0)",
    fill: "#ff4140"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3478",
    "data-name": "Tracciato 3478",
    d: "M4.271,96.342H17.027l4.251,8.93a8.5,8.5,0,0,1-.1,1.2c-.3,1.957-1.934,5.812-10.534,6.1-11.595.386-10.627-7.3-10.627-7.3Z",
    transform: "translate(0 28.877)",
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3479",
    "data-name": "Tracciato 3479",
    d: "M1.351,106.258A8,8,0,0,0,3.1,107.6a11.836,11.836,0,0,0,2.194.979c4.059,1.362,9.352,1.036,12.843-.98,2.1-1.21,3.143-2.8,3.138-4.385l.01,1.5c0,1.586-1.042,3.174-3.139,4.384-3.491,2.016-8.784,2.343-12.841.981a11.937,11.937,0,0,1-2.2-.98,8.025,8.025,0,0,1-1.749-1.34,4.323,4.323,0,0,1-1.339-2.983l-.01-1.5a4.325,4.325,0,0,0,1.34,2.983",
    transform: "translate(0.003 30.936)",
    fill: "#ffc400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3480",
    "data-name": "Tracciato 3480",
    d: "M14.792,95.69c2.852,1.59,2.945,4.214.209,5.861a11.14,11.14,0,0,1-10.116.1c-2.852-1.59-2.944-4.212-.211-5.859a11.147,11.147,0,0,1,10.117-.1",
    transform: "translate(0.805 28.333)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3481",
    "data-name": "Tracciato 3481",
    d: "M16.535,118.382c.074-23.051.149-62.308.224-85.359a3.642,3.642,0,0,0-2.21-3.015,11.192,11.192,0,0,0-10.156.1l-.175,85.37a11.144,11.144,0,0,1,10.116-.1,3.629,3.629,0,0,1,2.2,3",
    transform: "translate(1.264 8.645)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3482",
    "data-name": "Tracciato 3482",
    d: "M8.189,117.4h0l.2-85.359c-.058,20.745-.138,64.614-.2,85.359",
    transform: "translate(2.455 9.604)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3483",
    "data-name": "Tracciato 3483",
    d: "M8.189,117.4l.2-85.359Z",
    transform: "translate(2.455 9.604)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3484",
    "data-name": "Tracciato 3484",
    d: "M8.385,32.042l-.2,85.359c.058-20.745.138-64.614.2-85.359",
    transform: "translate(2.455 9.604)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3485",
    "data-name": "Tracciato 3485",
    d: "M8.189,117.4l.2-85.359Z",
    transform: "translate(2.455 9.604)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3486",
    "data-name": "Tracciato 3486",
    d: "M8.385,32.042l-.2,85.359Z",
    transform: "translate(2.455 9.604)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3487",
    "data-name": "Tracciato 3487",
    d: "M8.189,117.4h0l.2-85.359c-.058,20.745-.138,64.614-.2,85.359",
    transform: "translate(2.455 9.604)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3488",
    "data-name": "Tracciato 3488",
    d: "M8.385,32.042l-.2,85.359Z",
    transform: "translate(2.455 9.604)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3489",
    "data-name": "Tracciato 3489",
    d: "M8.385,32.042l-.2,85.359c.058-20.745.138-64.614.2-85.359",
    transform: "translate(2.455 9.604)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3490",
    "data-name": "Tracciato 3490",
    d: "M2.853,32.688l-.168,85.36a3.5,3.5,0,0,1,1.991-2.859l.177-85.369a3.515,3.515,0,0,0-2,2.869",
    transform: "translate(0.805 8.938)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3491",
    "data-name": "Tracciato 3491",
    d: "M17.216,32.061c-.01,2.987-.019,6.243-.03,9.71,0,1.413,0,2.866-.01,4.349,0,2.945-.009,6.013-.019,9.158,0,1.393-.01,2.817-.01,4.24-.01,3.036-.019,6.122-.03,9.239,0,1.373,0,2.755-.01,4.149,0,3.1-.009,6.2-.019,9.289,0,1.373-.01,2.745-.01,4.108-.01,3.166-.019,6.292-.03,9.339,0,1.373,0,2.726-.01,4.058,0,3.268-.009,6.4-.019,9.389,0,1.374-.01,2.706-.01,4.008,0,1.493-.01,2.946-.01,4.329A3.519,3.519,0,0,1,15,120.282a11.151,11.151,0,0,1-10.121.1,3.624,3.624,0,0,1-2.194-3.006l.01-4.528.01-4.7.019-8.658.009-4.71.01-8.658.01-4.71.019-8.647.01-4.73.019-8.628V54.657l.021-8.6.01-4.591.019-9.428a3.646,3.646,0,0,0,2.2,3,11.207,11.207,0,0,0,10.161-.11,3.5,3.5,0,0,0,1.994-2.866",
    transform: "translate(0.805 9.604)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3492",
    "data-name": "Tracciato 3492",
    d: "M4.813,30.111c-2.746,1.653-2.653,4.287.211,5.883a11.188,11.188,0,0,0,10.156-.1c2.746-1.652,2.651-4.287-.211-5.883a11.188,11.188,0,0,0-10.156.1",
    transform: "translate(0.843 8.644)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3493",
    "data-name": "Tracciato 3493",
    d: "M4.813,30.111c-2.746,1.653-2.653,4.287.211,5.883a11.184,11.184,0,0,0,10.156-.1c2.746-1.652,2.651-4.287-.211-5.883a11.188,11.188,0,0,0-10.156.1",
    transform: "translate(0.843 8.644)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3494",
    "data-name": "Tracciato 3494",
    d: "M2.816,33.827a3.586,3.586,0,0,1,2-2.753,6.415,6.415,0,0,1,3.017-5.446,10.973,10.973,0,0,0-3.7,3.846,10.7,10.7,0,0,0-1,2.4,9.566,9.566,0,0,0-.313,1.954",
    transform: "translate(0.844 7.682)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3495",
    "data-name": "Tracciato 3495",
    d: "M7.369,25.806a6.415,6.415,0,0,0-3.017,5.445,11.192,11.192,0,0,1,10.156-.1,3.715,3.715,0,0,1,2.207,2.9,9.782,9.782,0,0,0-.951-3.719,11.127,11.127,0,0,0-2.59-3.444,7.006,7.006,0,0,0-3.212-1.809,3.838,3.838,0,0,0-2.593.732",
    transform: "translate(1.304 7.505)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3496",
    "data-name": "Tracciato 3496",
    d: "M11.941,25.66c-1.47-.8-2.312-.9-4.111.144a2.784,2.784,0,0,1,2.191-.537A2.784,2.784,0,0,0,7.83,25.8,10.764,10.764,0,0,0,4.3,29.354,9.792,9.792,0,0,0,2.817,34c-.057,1.133.682,2.278,2.207,3.128a11.188,11.188,0,0,0,10.156-.1,3.456,3.456,0,0,0,2-2.985,9.392,9.392,0,0,0-.522-2.675,10.878,10.878,0,0,0-1.133-2.291,10.725,10.725,0,0,0-3.581-3.418",
    transform: "translate(0.843 7.505)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3497",
    "data-name": "Tracciato 3497",
    d: "M17.153,39.6c0,1.413,0,2.866-.01,4.349L17.064,44a13.886,13.886,0,0,1-7.035,1.755,14.257,14.257,0,0,1-6.794-1.6c-.149-.081-.3-.17-.441-.26L2.8,39.3c.049.781.741,1.573,1.894,2.224a12.157,12.157,0,0,0,10.822-.1A3.32,3.32,0,0,0,17.153,39.6",
    transform: "translate(0.837 11.779)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3498",
    "data-name": "Tracciato 3498",
    d: "M17.128,50.064c0,1.393-.01,2.815-.01,4.238-.019.01-.03.021-.049.03a13.977,13.977,0,0,1-7.034,1.753,14.144,14.144,0,0,1-6.8-1.613c-.16-.09-.311-.181-.46-.281V49.443H2.8c-.049.832.651,1.713,1.9,2.4a12.091,12.091,0,0,0,10.822-.1,3.516,3.516,0,0,0,1.6-1.683",
    transform: "translate(0.833 14.82)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3499",
    "data-name": "Tracciato 3499",
    d: "M17.095,60.456c0,1.373,0,2.755-.01,4.149a.01.01,0,0,1-.01.01,13.883,13.883,0,0,1-7.034,1.764,14.143,14.143,0,0,1-6.794-1.614,4.919,4.919,0,0,1-.491-.3l.01-4.73h.04c-.051.832.651,1.7,1.9,2.4a12.124,12.124,0,0,0,10.822-.1,3.714,3.714,0,0,0,1.564-1.583",
    transform: "translate(0.826 17.905)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3500",
    "data-name": "Tracciato 3500",
    d: "M17.072,70.809c0,1.373-.01,2.745-.01,4.108a13.937,13.937,0,0,1-7.015,1.753,14.262,14.262,0,0,1-6.794-1.613c-.181-.1-.36-.211-.521-.321l.01-4.709h.07c-.051.832.651,1.7,1.9,2.4a12.128,12.128,0,0,0,10.822-.1,3.768,3.768,0,0,0,1.534-1.523",
    transform: "translate(0.819 20.99)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3501",
    "data-name": "Tracciato 3501",
    d: "M17.036,81.174c0,1.373,0,2.726-.01,4.058a13.9,13.9,0,0,1-6.974,1.734,14.262,14.262,0,0,1-6.794-1.613c-.19-.11-.37-.211-.541-.33l.009-4.71h.091c-.051.832.651,1.713,1.9,2.415a12.128,12.128,0,0,0,10.822-.1,3.784,3.784,0,0,0,1.493-1.453",
    transform: "translate(0.814 24.072)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3502",
    "data-name": "Tracciato 3502",
    d: "M17.013,91.539c0,1.373-.01,2.706-.01,4.008a13.9,13.9,0,0,1-6.944,1.7,14.257,14.257,0,0,1-6.794-1.6c-.2-.11-.39-.23-.571-.351l.01-4.7.12.01c-.051.832.651,1.713,1.9,2.415a12.157,12.157,0,0,0,10.822-.1,3.918,3.918,0,0,0,1.464-1.383",
    transform: "translate(0.807 27.155)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3503",
    "data-name": "Tracciato 3503",
    d: "M7.923,29.635a1.624,1.624,0,0,1-1.508,1.718,1.733,1.733,0,0,1,0-3.436,1.624,1.624,0,0,1,1.508,1.718",
    transform: "translate(1.47 8.368)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3504",
    "data-name": "Tracciato 3504",
    d: "M21.5,8.618a3.248,3.248,0,0,1-3.017,3.438,3.248,3.248,0,0,1-3.015-3.438,3.247,3.247,0,0,1,3.015-3.436A3.247,3.247,0,0,1,21.5,8.618",
    transform: "translate(4.637 1.553)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_396",
    "data-name": "Raggruppa 396",
    transform: "translate(2.033 116.068)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_395",
    "data-name": "Raggruppa 395",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3505",
    "data-name": "Tracciato 3505",
    d: "M5.662,91.2l-3.27-1.9a6.486,6.486,0,0,0-.821,3.1l3.27,1.9a6.486,6.486,0,0,1,.821-3.1",
    transform: "translate(-1.564 -89.301)",
    fill: "#002747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3506",
    "data-name": "Tracciato 3506",
    d: "M4.839,93.588l-3.27-1.9a1.568,1.568,0,0,0,.706,1.344l3.27,1.9a1.568,1.568,0,0,1-.706-1.344",
    transform: "translate(-1.563 -88.586)",
    fill: "#00213d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_398",
    "data-name": "Raggruppa 398"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_397",
    "data-name": "Raggruppa 397",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3508",
    "data-name": "Tracciato 3508",
    d: "M15.336,75.793l-3.27-1.9L2.2,93.92l3.271,1.9Z",
    transform: "translate(0.66 22.148)",
    fill: "#002749"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_400",
    "data-name": "Raggruppa 400",
    transform: "translate(12.724 84.481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_399",
    "data-name": "Raggruppa 399",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3509",
    "data-name": "Tracciato 3509",
    d: "M17.232,66.9,13.962,65A64.005,64.005,0,0,1,9.791,76.557l3.27,1.9A64.005,64.005,0,0,0,17.232,66.9",
    transform: "translate(-9.79 -64.999)",
    fill: "#002747"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_402",
    "data-name": "Raggruppa 402",
    transform: "translate(36.52 45.05)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_401",
    "data-name": "Raggruppa 401",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3511",
    "data-name": "Tracciato 3511",
    d: "M35.811,37.033l-3.27-1.9a4.429,4.429,0,0,0-4.442.285l3.27,1.9a4.429,4.429,0,0,1,4.442-.285",
    transform: "translate(-28.098 -34.661)",
    fill: "#00213d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_404",
    "data-name": "Raggruppa 404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_403",
    "data-name": "Raggruppa 403",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3513",
    "data-name": "Tracciato 3513",
    d: "M32.268,37.143,29,35.243l-3.9,2.251,3.27,1.9Z",
    transform: "translate(7.522 10.564)",
    fill: "#00203c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3514",
    "data-name": "Tracciato 3514",
    d: "M29.266,38.876,26,36.976l-3.9,2.263,3.27,1.9Z",
    transform: "translate(6.623 11.083)",
    fill: "#00203c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3515",
    "data-name": "Tracciato 3515",
    d: "M22.181,47.126l-3.27-1.9L13,70.926l3.27,1.9Z",
    transform: "translate(3.897 13.556)",
    fill: "#002749"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3516",
    "data-name": "Tracciato 3516",
    d: "M34.667,39.132l-3.9,2.263c-2.519,1.466-5.178,5.263-5.911,8.46l-5.911,25.7a63.982,63.982,0,0,1-4.171,11.559L4.908,107.142c-1.564,3.175-.846,5.2,1.6,4.511L30.52,104.89a21.214,21.214,0,0,0,4.327-1.964,29.367,29.367,0,0,0,4.531-3.173L63.326,78.722c2.437-2.134,3.121-4.973,1.535-6.308L54.7,63.949a16.528,16.528,0,0,1-4.244-6.666l-5.968-18.8c-.738-2.347-3.411-3.066-5.919-1.606Z",
    transform: "translate(1.223 10.827)",
    fill: "#00447d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_406",
    "data-name": "Raggruppa 406",
    transform: "translate(22.806 50.322)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_405",
    "data-name": "Raggruppa 405",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3517",
    "data-name": "Tracciato 3517",
    d: "M26.03,40.617l-3.27-1.9a11.213,11.213,0,0,0-2.879,2.593l3.27,1.9a11.213,11.213,0,0,1,2.879-2.593",
    transform: "translate(-16.847 -38.717)",
    fill: "#00213d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3518",
    "data-name": "Tracciato 3518",
    d: "M23.85,42.612l-3.27-1.9a15.3,15.3,0,0,0-3.032,5.866l3.27,1.9a15.305,15.305,0,0,1,3.032-5.867",
    transform: "translate(-17.547 -38.119)",
    fill: "#002747"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_408",
    "data-name": "Raggruppa 408"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_407",
    "data-name": "Raggruppa 407",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3520",
    "data-name": "Tracciato 3520",
    d: "M25.375,80.628l-6.54-3.8L14.917,94.069l6.54,3.8Z",
    transform: "translate(4.471 23.028)",
    fill: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3521",
    "data-name": "Tracciato 3521",
    d: "M24.356,56.017l-6.54-3.8L17.965,84.2l6.54,3.8Z",
    transform: "translate(5.34 15.651)",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3522",
    "data-name": "Tracciato 3522",
    d: "M24.3,42.559l-6.54-3.8.079,17.492,6.54,3.8Z",
    transform: "translate(5.322 11.617)",
    fill: "#969696"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_410",
    "data-name": "Raggruppa 410",
    transform: "translate(32.974 24.553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_409",
    "data-name": "Raggruppa 409",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3523",
    "data-name": "Tracciato 3523",
    d: "M35.7,23.49l-6.54-3.8c-1.47-.855-2.875-1.019-3.793-.513l6.542,3.8c.916-.507,2.321-.342,3.791.512",
    transform: "translate(-25.37 -18.891)",
    fill: "#848484"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_412",
    "data-name": "Raggruppa 412",
    transform: "translate(23.075 24.838)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_411",
    "data-name": "Raggruppa 411",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3525",
    "data-name": "Tracciato 3525",
    d: "M32.253,22.911l-6.54-3.8a6.224,6.224,0,0,0-1.486,1.419l6.54,3.8a6.278,6.278,0,0,1,1.486-1.419",
    transform: "translate(-15.814 -19.11)",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3526",
    "data-name": "Tracciato 3526",
    d: "M32.708,24l-6.54-3.8c-3.232,3.956-8.382,14.621-8.413,24.117l6.54,3.8c.032-9.5,5.181-20.16,8.413-24.117",
    transform: "translate(-17.754 -18.782)",
    fill: "#9a9a9a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_414",
    "data-name": "Raggruppa 414"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_413",
    "data-name": "Raggruppa 413",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3528",
    "data-name": "Tracciato 3528",
    d: "M47.805,98.207l-14.029,8.136L19.948,114.36l3.919-17.245-.14-30-.01-1.985-.01-2.625-.07-14.86c.04-11.163,7.145-23.939,9.9-25.542,2.746-1.513,9.87,2.985,10,14l.07,14.911.009,2.6.01,2.015.13,29.972Z",
    transform: "translate(5.979 6.539)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3529",
    "data-name": "Tracciato 3529",
    d: "M46.719,77.984l1.088,3.388L33.775,89.509,19.95,97.524l1.067-4.7Z",
    transform: "translate(5.98 23.374)",
    fill: "#ff4140"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3530",
    "data-name": "Tracciato 3530",
    d: "M22.565,90.138l-1.107,4.875-6.542-3.8,1.1-4.855Z",
    transform: "translate(4.471 25.885)",
    fill: "#d83736"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_416",
    "data-name": "Raggruppa 416",
    transform: "translate(53.699 104.215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_415",
    "data-name": "Raggruppa 415",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3531",
    "data-name": "Tracciato 3531",
    d: "M41.61,84.627l2.18-1.267a.75.75,0,0,0,.342-.412,4.24,4.24,0,0,0-.636-2.766l-2.18,1.267a4.242,4.242,0,0,1,.634,2.765.752.752,0,0,1-.341.413",
    transform: "translate(-41.315 -80.182)",
    fill: "#002747"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_418",
    "data-name": "Raggruppa 418"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_417",
    "data-name": "Raggruppa 417",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3533",
    "data-name": "Tracciato 3533",
    d: "M44.4,87.71l2.18-1.267L33.206,59.3l-2.181,1.267Z",
    transform: "translate(9.299 17.773)",
    fill: "#002747"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_420",
    "data-name": "Raggruppa 420",
    transform: "translate(39.941 76.257)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_419",
    "data-name": "Raggruppa 419",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3534",
    "data-name": "Tracciato 3534",
    d: "M31.113,60.751l2.18-1.267c-.127-.255-.255-.545-.383-.812l-2.18,1.267c.127.266.256.556.383.812",
    transform: "translate(-30.73 -58.671)",
    fill: "#002747"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_422",
    "data-name": "Raggruppa 422"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_421",
    "data-name": "Raggruppa 421",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3536",
    "data-name": "Tracciato 3536",
    d: "M30.748,59.646,30.67,87.232l12.7,3.582c.929.252,1.583.095,1.773-.443a4.247,4.247,0,0,0-.636-2.766L31.131,60.458c-.127-.256-.256-.546-.383-.812",
    transform: "translate(9.193 17.878)",
    fill: "#00335f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3537",
    "data-name": "Tracciato 3537",
    d: "M25.166,40.324c0,1.934,3.291,1.6,7.351-.742s7.35-5.811,7.35-7.745-3.291-1.6-7.35.742-7.351,5.811-7.351,7.745",
    transform: "translate(7.543 9.165)",
    fill: "#002747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3538",
    "data-name": "Tracciato 3538",
    d: "M42.76,48.886,22.86,60.38,22.85,58.4l-.01-2.625,19.9-11.494.009,2.594Z",
    transform: "translate(6.846 13.271)",
    fill: "#00447d"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ3);
export default __webpack_public_path__ + "static/media/q3.a264a62e361a82ee8318ac8144ad84af.svg";
export { ForwardRef as ReactComponent };